module.exports = __webpack_public_path__ + "static/media/home-img.e15fc8d6.jpg";